<app-header></app-header>
<div class="content_wrapper" id="report_page">
    <div class="row">
        <div class="col-lg-9">

            <div class="an-top filter-header">
                <div class="summary-mentions">
                    <div class="spinner-border"></div>
                    <h2>Pdf Report</h2>
                </div>
                <div class="bt-top">            
                    <div class="popover-wrapper">
                        <input type="text"
                               ngxDaterangepickerMd
                               [(ngModel)]="selected"
                               [alwaysShowCalendars]="alwaysShowCalendars"
                               [ranges]="ranges"
                               [showClearButton]="true"
                               [showCancel]="true"
                               [linkedCalendars]="true"
                               [locale]="{applyLabel: 'Apply'}"
                               (datesUpdated)="datesUpdated($event)"
                               [keepCalendarOpeningWithRange]="keepCalendarOpeningWithRange"
                               [showRangeLabelOnInput]="showRangeLabelOnInput"
                               class="form-control"/>
                    </div>
                </div>
            </div>
            <form [formGroup]="form" (ngSubmit)="generate_report(form.value)">
                <div class="choose_rpt_sec">
                    <div  class="summary-title">
                        <i  class="fa fa-cog"></i><h2>Choose report content</h2>
                    </div>
                    <div  class="summary-title">
                        <i  class="fa fa-toggle-on"></i><h2>Include file</h2>
                        <!--<a href="">Restore Default</a>-->
                    </div>
                    <div class="check-pdf-sec">
                        <div  class="pdf-edit-checkbox">
                            <h4><i  class="fa fa-file-text-o"></i> Summary of mentions</h4>
                            <label class="switch">
                                <input type="checkbox" checked="" formControlName="summary">
                                <span  class="slider round"></span>
                            </label>
                        </div>

                        <!--                    <div  class="pdf-edit-checkbox">
                                                <h4><i  class="fa fa-wifi"></i>Social media reach graph</h4>
                                                <label class="switch"><input  type="checkbox" checked="">
                                                    <span  class="slider round"></span>
                                                </label>
                                            </div>-->

                        <div  class="pdf-edit-checkbox">
                            <h4><i  class="fa fa-share-alt"></i>Volume of mentions per category</h4>
                            <label class="switch">
                                <input  type="checkbox" checked="" formControlName="mentions_by_category">
                                <span  class="slider round"></span>
                            </label>
                        </div>

                        <!--                    <div  class="pdf-edit-checkbox">
                                                <h4><i  class="fa fa-share-alt"></i>Context of discussion</h4>
                                                <label class="switch"><input  type="checkbox" checked="">
                                                    <span  class="slider round"></span>
                                                </label>
                                            </div>-->

                        <div  class="pdf-edit-checkbox">
                            <h4><i  class="fa fa-thumbs-up"></i>Recent mentions</h4>
                            <label class="switch"><input  type="checkbox" checked="" formControlName="latest_mentions">
                                <span  class="slider round"></span>
                            </label>
                        </div>

                        <div  class="pdf-edit-checkbox">
                            <h4><i  class="fa fa-bullseye"></i>Top public profiles</h4>
                            <label class="switch"><input  type="checkbox" checked="" formControlName="top_profiles">
                                <span  class="slider round"></span>
                            </label>
                        </div>

                        <!--                        <div  class="pdf-edit-checkbox">
                                                    <h4><i  class="fa fa-bullhorn"></i> Most influential sites</h4>
                                                    <label class="switch"><input  type="checkbox" checked="" formControlName="influential_sites">
                                                        <span  class="slider round"></span>
                                                    </label>
                                                </div>-->

                        <div  class="pdf-edit-checkbox">
                            <h4><i  class="fa fa-quote-left"></i> Quotes</h4>
                            <label class="switch"><input  type="checkbox" checked="" formControlName="quotes">
                                <span  class="slider round"></span>
                            </label>
                        </div>

                        <div  class="pdf-edit-checkbox">
                            <h4><i  class="fa fa-chart-bar"></i>Volume of mentions graph</h4>
                            <label class="switch"><input  type="checkbox" checked="" formControlName="mentions_graph">
                                <span  class="slider round"></span>
                            </label>
                        </div>

                        <!--                    <div  class="pdf-edit-checkbox">
                                                <h4><i  class="fa fa-chart-network"></i> Non social reach graph</h4>
                                                <label class="switch"><input  type="checkbox" checked="">
                                                    <span  class="slider round"></span>
                                                </label>
                                            </div>-->

                        <div  class="pdf-edit-checkbox">
                            <h4><i  class="fa fa-bookmark"></i> Numerical summary</h4>
                            <label class="switch"><input  type="checkbox" checked="" formControlName="numerical_summary">
                                <span  class="slider round"></span>
                            </label>
                        </div>

                        <div  class="pdf-edit-checkbox">
                            <h4><i  class="fa fa-star"></i>Most popular mentions</h4>
                            <label class="switch"><input  type="checkbox" checked="" formControlName="popular_mentions">
                                <span  class="slider round"></span>
                            </label>
                        </div>

                        <!--                        <div  class="pdf-edit-checkbox">
                                                    <h4><i  class="fa fa-user-circle"></i>Most active public profiles</h4>
                                                    <label class="switch"><input  type="checkbox" checked="" formControlName="active_profiles">
                                                        <span  class="slider round"></span>
                                                    </label>
                                                </div>-->

                        <!--                        <div  class="pdf-edit-checkbox">
                                                    <h4><i  class="fa fa-chart-line"></i>Most active sites</h4>
                                                    <label class="switch"><input  type="checkbox" checked="" formControlName="active_sites">
                                                        <span  class="slider round"></span>
                                                    </label>
                                                </div>-->

                        <!--                        <div  class="pdf-edit-checkbox">
                                                    <h4><i  class="fa fa-hashtag"></i>Trending hashtags</h4>
                                                    <label class="switch"><input  type="checkbox" checked="" formControlName="hashtags">
                                                        <span  class="slider round"></span>
                                                    </label>
                                                </div>-->

                    </div>
                </div>

                <div class="an-top filter-header go-sec mt-2">
                    <div class="summary-mentions">
                        <div class="spinner-border"></div>
                        <!--<a href="">Go back</a>-->
                    </div>
                    <div class="bt-top">            
                        <div class="popover-wrapper">
                            <button class="submit-mention btn">Generate Report</button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div class="col-lg-3">
        </div>

    </div>
    <div style="width: 695px;height:250px;position: absolute;top: -200px;"> 
        <canvas id="linechart" baseChart
                [datasets]="lineChartData"
                [options]="lineChartOptions"
                [legend]="lineChartLegend"
                [chartType]="lineChartType"
                [plugins]="lineChartPlugins">
        </canvas>
    </div>
</div>
<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "rgb(199, 28, 109)" type = "square-loader" [fullScreen] = "true"></ngx-spinner>
<app-footer></app-footer>
<style>
    page {
        background: white;
        display: block;
        margin: 0 auto;
        margin-bottom: 0.5cm;
        box-shadow: 0 0 0.5cm rgba(0,0,0,0.5);
    }
    page[size="A4"] {  
        width: 21cm;
        height: 29.7cm; 
    }
</style>